// export function multiPartData(data, parentKey = "", form = new FormData()) {
//   for (let key in data) {
//     const fullKey = parentKey ? `${parentKey}.${key}` : key;
//     const value = data[key];

//     if (fullKey === "email" || (!value && fullKey === "company_name")) continue;

//     if (value && typeof value === "object" && !(value instanceof File)) {
//       multiPartData(value, fullKey, form); // recurse
//     } else {
//       form.append(fullKey, value ?? "");
//     }
//   }
//   return form;
// }

export function multiPartData(data, parentKey = "", form = new FormData()) {
  for (let key in data) {
    const fullKey = parentKey ? `${parentKey}.${key}` : key;
    const value = data[key];

    // Email hamesha skip karo
    if (fullKey === "email") continue;

    // Company_name special case - empty value bhi append karo
    if (fullKey === "company_name") {
      form.append(fullKey, value || ""); // Empty string bhejo
      continue;
    }

    // Baqi fields ke liye: agar value empty hai to skip karo
    if (!value) continue;

    // Agar value object hai aur File nahi hai to recurse karo
    if (typeof value === "object" && !(value instanceof File)) {
      multiPartData(value, fullKey, form);
    } else {
      form.append(fullKey, value);
    }
  }
  return form;
}

export function multiPartData2(data, parentKey = "", form = new FormData()) {
  for (let key in data) {
    const value = data[key];

    // build key
    const fullKey = parentKey ? `${parentKey}.${key}` : key;

    if (value instanceof Date) {
      form.append(fullKey, value.toISOString());
    } else if (value instanceof File) {
      form.append(fullKey, value);
    } else if (Array.isArray(value)) {
      value.forEach((item, index) => {
        // vehicle_images[0]
        const arrayKey = `${fullKey}[${index}]`;

        if (item instanceof File) {
          // rare case: array of files
          form.append(arrayKey, item);
        } else if (typeof item === "object" && item !== null) {
          // recurse object inside array
          multiPartData2(item, arrayKey, form);
        } else {
          form.append(arrayKey, item ?? "");
        }
      });
    } else if (value && typeof value === "object") {
      multiPartData2(value, fullKey, form);
    } else {
      form.append(fullKey, value ?? "");
    }
  }

  return form;
}

// export function multiPartData2(data, parentKey = "", form = new FormData()) {
//   for (let key in data) {
//     const fullKey = parentKey ? `${parentKey}.${key}` : key;
//     const value = data[key];

//     if (value instanceof Date) {
//       form.append(fullKey, value.toISOString());
//     } else if (value instanceof File) {
//       form.append(fullKey, value);
//     } else if (Array.isArray(value)) {
//       value.forEach((item, index) => {
//         const arrayKey = `${fullKey}[${index}]`;
//         if (item instanceof File) {
//           form.append(arrayKey, item);
//         } else if (typeof item === "object" && item !== null) {
//           multiPartData2(item, arrayKey, form);
//         } else {
//           form.append(arrayKey, item ?? "");
//         }
//       });
//     } else if (value && typeof value === "object") {
//       multiPartData2(value, fullKey, form); // Recurse for nested objects
//     } else {
//       form.append(fullKey, value ?? "");
//     }
//   }
//   return form;
// }

// export function multiPartData2(data, parentKey = "", form = new FormData()) {
//   for (let key in data) {
//     const fullKey = parentKey ? `${parentKey}.${key}` : key;
//     const value = data[key];

//     if (value instanceof Date) {
//       form.append(fullKey, value.toISOString());
//     } else if (value instanceof File) {
//       form.append(fullKey, value);
//     } else if (Array.isArray(value)) {
//       value.forEach((item) => {
//         if (item instanceof File) {
//           form.append(fullKey, item); // Repeated key for images
//         } else if (typeof item === "object" && item !== null) {
//           multiPartData2(item, fullKey, form);
//         } else {
//           form.append(fullKey, item ?? "");
//         }
//       });
//     } else if (value && typeof value === "object") {
//       multiPartData2(value, fullKey, form); // Recurse for nested objects
//     } else {
//       form.append(fullKey, value ?? "");
//     }
//   }
//   return form;
// }

// export function getWedThursDates(startDate, endDate, activeDays) {
//   let result = 0;
//   let current = new Date(startDate + "T00:00:00");
//   let end = new Date(endDate + "T00:00:00");
//   end.setMinutes(end.getMinutes() + 1);
//   let length = activeDays.length;
//   for (let i = 0; current <= end; i++) {
//     switch (length) {
//       case 1:
//         if (current.getDay() === activeDays[0]) {
//           result++;
//         }
//         break;
//       case 2:
//         if (
//           current.getDay() === activeDays[0] ||
//           current.getDay() === activeDays[1]
//         ) {
//           result++;
//         }
//         break;
//       case 3:
//         if (
//           current.getDay() === activeDays[0] ||
//           current.getDay() === activeDays[1] ||
//           current.getDay() === activeDays[2]
//         ) {
//           result++;
//         }
//         break;
//       case 4:
//         if (
//           current.getDay() === activeDays[0] ||
//           current.getDay() === activeDays[1] ||
//           current.getDay() === activeDays[2] ||
//           current.getDay() === activeDays[3]
//         ) {
//           result++;
//         }
//         break;
//       case 5:
//         if (
//           current.getDay() === activeDays[0] ||
//           current.getDay() === activeDays[1] ||
//           current.getDay() === activeDays[2] ||
//           current.getDay() === activeDays[3] ||
//           current.getDay() === activeDays[4]
//         ) {
//           result++;
//         }
//         break;
//       case 6:
//         if (
//           current.getDay() === activeDays[0] ||
//           current.getDay() === activeDays[1] ||
//           current.getDay() === activeDays[2] ||
//           current.getDay() === activeDays[3] ||
//           current.getDay() === activeDays[4] ||
//           current.getDay() === activeDays[5]
//         ) {
//           result++;
//         }
//         break;
//       case 7:
//         if (
//           current.getDay() === activeDays[0] ||
//           current.getDay() === activeDays[1] ||
//           current.getDay() === activeDays[2] ||
//           current.getDay() === activeDays[3] ||
//           current.getDay() === activeDays[4] ||
//           current.getDay() === activeDays[5] ||
//           current.getDay() === activeDays[6]
//         ) {
//           result++;
//         }
//         break;
//       default:
//         return 0;
//     }
//     current.setDate(current.getDate() + 1);
//   }
//   console.log(result);

//   return result;
// }

// export function getWedThursDates(startDate, endDate, activeDays) {
//   console.log(startDate, endDate, activeDays);

//   let result = 0;
//   let current = new Date(startDate + "T00:00:00");
//   let end = new Date(endDate + "T00:00:00");
//   end.setMinutes(end.getMinutes() + 1);

//   const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
//   let length = activeDays.length;

//   for (let i = 0; current <= end; i++) {
//     const dayName = daysOfWeek[current.getDay()]; // Get the day name (e.g., "Sun", "Mon", etc.)
//     console.log("dayName", dayName);

//     switch (length) {
//       case 1:
//         if (dayName === activeDays["Sun"]) {
//           result++;
//         }
//         break;
//       case 2:
//         if (dayName === activeDays["Sun"] || dayName === activeDays["Mon"]) {
//           result++;
//         }
//         break;
//       case 3:
//         if (
//           dayName === activeDays["Sun"] ||
//           dayName === activeDays["Mon"] ||
//           dayName === activeDays["Tue"]
//         ) {
//           result++;
//         }
//         break;
//       case 4:
//         if (
//           dayName === activeDays["Sun"] ||
//           dayName === activeDays["Mon"] ||
//           dayName === activeDays["Tue"] ||
//           dayName === activeDays["Wed"]
//         ) {
//           result++;
//         }
//         break;
//       case 5:
//         if (
//           dayName === activeDays["Sun"] ||
//           dayName === activeDays["Mon"] ||
//           dayName === activeDays["Tue"] ||
//           dayName === activeDays["Wed"] ||
//           dayName === activeDays["Thu"]
//         ) {
//           result++;
//         }
//         break;
//       case 6:
//         if (
//           dayName === activeDays["Sun"] ||
//           dayName === activeDays["Mon"] ||
//           dayName === activeDays["Tue"] ||
//           dayName === activeDays["Wed"] ||
//           dayName === activeDays["Thu"] ||
//           dayName === activeDays["Fri"]
//         ) {
//           result++;
//         }
//         break;
//       case 7:
//         if (
//           dayName === activeDays["Sun"] ||
//           dayName === activeDays["Mon"] ||
//           dayName === activeDays["Tue"] ||
//           dayName === activeDays["Wed"] ||
//           dayName === activeDays["Thu"] ||
//           dayName === activeDays["Fri"] ||
//           dayName === activeDays["Sat"]
//         ) {
//           result++;
//         }
//         break;
//       default:
//         return 0;
//     }
//     current.setDate(current.getDate() + 1);
//   }

//   console.log(result);

//   return result;
// }

export function getWedThursDates(startDate, endDate, activeDays) {
  let result = 0;
  let current = new Date(startDate + "T00:00:00");
  let end = new Date(endDate + "T00:00:00");
  end.setMinutes(end.getMinutes() + 1);

  const daysOfWeek = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
  ];

  // Loop through the days from startDate to endDate
  while (current <= end) {
    const dayName = daysOfWeek[current.getDay()]; // Get the day name (e.g., "Sun", "Mon", etc.)

    // Check if the current day is in the activeDays array
    if (activeDays.includes(dayName)) {
      result++;
    }

    // Move to the next day
    current.setDate(current.getDate() + 1);
  }

  return result;
}

export const getErrorMessage = (error) => {
  if (error && typeof error === "object" && "data" in error && error.data) {
    return error.data.message || "An error occurred";
  }
  return "An error occurred";
};

// Parse date string as local date to avoid UTC timezone shift
// e.g. "2026-02-17T19:00:00.000Z" (midnight PKT stored as UTC) → Feb 18 local
// export const parseLocalDate = (dateStr) => {
//   if (!dateStr) return null;
//   const d = new Date(dateStr);
//   if (isNaN(d.getTime())) return null;
//   return new Date(d.getFullYear(), d.getMonth(), d.getDate());
// };
export const parseLocalDate = (dateStr) => {
  if (!dateStr) return null;

  // T wala format
  if (dateStr.includes("T")) {
    const datePart = dateStr.split("T")[0]; // time ignore
    const [year, month, day] = datePart.split("-");
    return new Date(year, month - 1, day); // ✅
  }

  // "2026-02-17" format
  const [year, month, day] = dateStr.split("-");
  return new Date(year, month - 1, day); // ✅
};
